import { render, staticRenderFns } from "./holographic.vue?vue&type=template&id=241e09c7&scoped=true&"
import script from "./holographic.vue?vue&type=script&lang=js&"
export * from "./holographic.vue?vue&type=script&lang=js&"
import style0 from "./holographic.vue?vue&type=style&index=0&id=241e09c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241e09c7",
  null
  
)

export default component.exports